import React, { Component } from "react";
import { MDBBtn } from "mdb-react-ui-kit";
import "./AdminProjectDetail.css";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import Logger from "Projects/CC_cubi_clan_project/Utils/Logger";

// Uploader de imagen
// (ya no se usa directamente aquí; lo usa HeaderImgSection)
// import { ImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/ImageUploader/ImageUploader";

// Modales
import CastItemModal from "./modals/CastItemModal";
import GalleryItemModal from "./modals/GalleryItemModal";
import VideoItemModal from "./modals/VideoItemModal";
import VenueItemModal from "./modals/VenueItemModal";
import CommentItemModal from "./modals/CommentItemModal";

// Portal para elementos fijados a viewport (reutilizamos el de modales)
import ModalPortal from "./modals/ModalPortal";

// Secciones existentes
import TitleSection from "./sections/TitleSection";
import ThemeAudioSection from "./sections/ThemeAudioSection";
import SynopsisSection from "./sections/SynopsisSection";
import CastSection from "./sections/CastSection";
import GallerySection from "./sections/GallerySection";
import VideosSection from "./sections/VideosSection";
import VenuesSection from "./sections/VenuesSection";
import CommentsSection from "./sections/CommentsSection";

// NUEVAS secciones
import HeaderImgSection from "./sections/HeaderImgSection";
import DescriptionSection from "./sections/DescriptionSection";

const stripDataUrl = (dataUri) =>
  dataUri && String(dataUri).startsWith("data:image")
    ? String(dataUri).replace(/^data:image\/[a-zA-Z0-9+.+-]+;base64,/, "")
    : dataUri || "";

export default class AdminProjectDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idFromProps: false,
      project: {
        imageBase64: "",
        imageUuid: null,
        description: "",
        title: "Proyecto nuevo",
        synopsis: "",
        themeUrl: "",
        status: "draft",
        personajes: [],
        fotos: [],
        videos: [],
        representaciones: [],
        comentarios: [],
      },
      modal: { type: null, index: -1, open: false, payload: null },
      savedProject: null, // snapshot del último estado guardado en backend
    };
    this._mounted = false;
  }

  componentDidMount() {
    this._mounted = true;
    let id = this.getProductId();
    this.initProjectData(id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.projectId !== prevProps.projectId) {
      this.initProjectData(this.props.projectId);
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  getProductId() {
    let id = this.getProductIdFromProps();
    if (!id) {
      id = this.getProductIdFromUrl();
    } else {
      this.setState({ idFromProps: true });
    }
    return id;
  }

  getProductIdFromProps(props) {
    return this.props.projectId;
  }

  getProductIdFromUrl() {
    const location = "" + window.location;
    const match = location.match(/project\/([^/]+)$/);

    if (match) {
      const slug = match[1];
      return slug;
    } else {
      return null;
    }
  }

  // ----------------- Data -----------------
  initProjectData = (id) => {
    if (id == null) {
      // Nuevo proyecto
      this.setState({
        project: {
          imageBase64: "",
          imageUuid: null,
          description: "",
          title: "Proyecto nuevo",
          synopsis: "",
          themeUrl: "",
          status: "draft",
          personajes: [],
          fotos: [],
          videos: [],
          representaciones: [],
          comentarios: [],
        },
      });
    } else {
      this.loadProject(id);
    }
  };

  loadProject = (id) => {
    this.props.onLoading && this.props.onLoading(true);
    const requestOptions = { method: "GET" };
    const method = "getProyecto?slug=" + id;

    doFetch("MUGIN", method, requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (!this._mounted) return;
        const incoming = data?.DATA || {};
        Logger.debug("MUGIN", "AdminProjectDetail.loadProject", {
          personajes: (incoming.personajes || []).length,
          personajesData: (incoming.personajes || []).map(per => ({
            id: per.idPersonaje, name: per.name,
            roles: (per.roles || []).map(r => ({
              idRol: r.idRol,
              actor: r.actor?.name,
              roleImg: r.imageBase64 ? "SI" : "NO",
            }))
          }))
        });
        const loadedProject = {
            imageBase64: incoming.imageBase64 || "",
            imageUuid: incoming.imageUuid || null,
            description: incoming.description || "",
            ...incoming,
            personajes: incoming.personajes || [],
            fotos: incoming.fotos || [],
            videos: incoming.videos || [],
            representaciones: incoming.representaciones || [],
            comentarios: incoming.comentarios || [],
          };
        this.setState({
          project: loadedProject,
          savedProject: loadedProject,
        });
      })
      .catch((error) => {
        console.error(error);
        if (!this._mounted) return;
      })
      .finally(() => {
        this.props.onLoading && this.props.onLoading(false);
      });
  };

  updateProjectField = (field, value) => {
    this.setState((s) => ({ project: { ...s.project, [field]: value } }));
  };

  upsertItem = (collectionKey, index, item, onComplete) => {
    this.setState((s) => {
      const arr = (s.project[collectionKey] || []).slice();
      if (index == null || index < 0) arr.push(item);
      else arr[index] = item;
      return { project: { ...s.project, [collectionKey]: arr } };
    }, onComplete);
  };

  removeItem = (collectionKey, index) => {
    this.setState((s) => {
      const arr = (s.project[collectionKey] || []).slice();
      arr.splice(index, 1);
      return { project: { ...s.project, [collectionKey]: arr } };
    });
  };

  // ----------------- Modales -----------------
  openModal = (type, index = -1, payload = null) => {
    this.setState({ modal: { type, index, open: true, payload } });
  };

  closeModal = () => {
    this.setState({
      modal: { type: null, index: -1, open: false, payload: null },
    });
  };

  // ----------------- Guardar -----------------
  // options.noReload: true → no recarga el proyecto tras guardar (preserva edits locales de otros campos)
  // options.successMessage: mensaje de toast personalizado
  handleSave = (projectOverride, options = {}) => {
    const project = projectOverride || this.state.project;
    const { noReload = false, successMessage = "Proyecto guardado correctamente" } = options;
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify([project]),
    };
    this.props.onLoading && this.props.onLoading(true);
    doFetch("MUGIN", "upsertProyectos", requestOptions)
      .then((r) => r.json().catch(() => ({})))
      .then((res) => {
        if (res?.STATE === "SUCCESS") {
          const proyectosResult = res?.DATA;
          const newSlug = proyectosResult?.[0]?.slug;
          const projectSlug = this.state.project.slug || newSlug;
          if (noReload) {
            // Solo actualiza el snapshot savedProject; no recarga para no perder edits locales
            this.setState({ savedProject: project });
          } else if (projectSlug) {
            this.loadProject(projectSlug);
          }
          toast.show({
            message: successMessage,
            type: "success",
            position: "bottom-center",
            size: "wide",
            animation: "slide",
            timeout: 3000,
          });
        } else {
          toast.show({
            message:
              "Ha ocurrido un error al guardar el proyecto: " + res?.MESSAGE,
            type: "danger",
            position: "bottom-center",
            size: "wide",
            animation: "slide",
            timeout: 3000, // o 0 si quieres sólo manual
          });
        }
      })
      .catch((e) => {
        console.error(e);
        toast.show({
          message: "Ha ocurrido un error no controlado al guardar el proyecto",
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 3000, // o 0 si quieres sólo manual
        });
      })
      .finally(() => {
        this.props.onSave && this.props.onSave();
        this.props.onLoading && this.props.onLoading(false);
      });
  };

  // Guarda solo los cambios de personajes del modal sin afectar edits pendientes de otros campos
  handleSaveCastOnly = () => {
    const { savedProject, project } = this.state;
    if (!savedProject) {
      // Proyecto nuevo, nunca guardado: guardar completo
      this.handleSave();
      return;
    }
    const castPayload = { ...savedProject, personajes: project.personajes };
    this.handleSave(castPayload, { noReload: true, successMessage: "Personaje guardado" });
  };

  handleSaveVenueOnly = () => {
    const { savedProject, project } = this.state;
    if (!savedProject) {
      this.handleSave();
      return;
    }
    const venuePayload = { ...savedProject, representaciones: project.representaciones };
    this.handleSave(venuePayload, { noReload: true, successMessage: "Representación guardada" });
  };

  handleClose = () => {
    this.props.onClose?.();
  };

  onBack = () => {
    this.props.onHandleNavLinks &&
      this.props.onHandleNavLinks({ force: "Projects" }, "/projects");
  };

  // ----------------- Render -----------------
  render() {
    const { idFromProps, project, modal } = this.state;

    return (
      <div className="project-detail">
        {!idFromProps && (
          <button className="back-link" onClick={() => this.onBack()}>
            ← Volver
          </button>
        )}

        {/* Imagen del proyecto (HeaderImgSection) */}
        <HeaderImgSection
          imageUuid={project.imageUuid || null}
          onUpload={(uuid) => this.updateProjectField("imageUuid", uuid)}
          onDelete={() => this.updateProjectField("imageUuid", null)}
        />

        {/* Título */}
        <TitleSection
          value={project.title || ""}
          onChange={(val) => this.updateProjectField("title", val)}
        />

        {/* Descripción breve (DescriptionSection) */}
        <DescriptionSection
          value={project.description || ""}
          onChange={(val) => this.updateProjectField("description", val)}
        />

        {/* URL del tema + reproductor autónomo */}
        <ThemeAudioSection
          url={project.themeUrl || ""}
          onUrlChange={(val) => this.updateProjectField("themeUrl", val)}
        />

        {/* Sinopsis */}
        <SynopsisSection
          html={project.synopsis || ""}
          onHtmlChange={(html) => this.updateProjectField("synopsis", html)}
        />

        {/* Reparto */}
        <CastSection
          personajes={project.personajes || []}
          onEdit={(idx, item, roleIndex = -1) =>
            this.openModal("cast", idx, { item, roleIndex })
          }
          onCreate={() => this.openModal("cast", -1, null)}
          onChange={(newArr) => this.updateProjectField("Maestros", newArr)}
        />

        {/* Galería */}
        <GallerySection
          fotos={project.fotos || []}
          onEdit={(idx, item) => this.openModal("gallery", idx, item)}
          onCreate={() => this.openModal("gallery", -1, null)}
          onChange={(newArr) => this.updateProjectField("fotos", newArr)}
        />

        {/* Vídeos */}
        <VideosSection
          videos={project.videos || []}
          onEdit={(idx, item) => this.openModal("video", idx, item)}
          onCreate={() => this.openModal("video", -1, null)}
          onChange={(newArr) => this.updateProjectField("videos", newArr)}
        />

        {/* Lugares */}
        <VenuesSection
          venues={project.representaciones || []}
          onEdit={(idx, item) => this.openModal("venue", idx, item)}
          onCreate={() => this.openModal("venue", -1, null)}
          onChange={(newArr) =>
            this.updateProjectField("representaciones", newArr)
          }
        />

        {/* Comentarios */}
        <CommentsSection
          comments={project.comentarios || []}
          onEdit={(idx, item) => this.openModal("comment", idx, item)}
          onCreate={() => this.openModal("comment", -1, null)}
          onChange={(newArr) => this.updateProjectField("comentarios", newArr)}
        />

        {/* Botones viewport via Portal (SIEMPRE visibles) */}
        <ModalPortal>
          <div className="project-fixed-save">
            <MDBBtn className="mugin-btn-primary" onClick={() => this.handleSave()}>
              Guardar proyecto
            </MDBBtn>
          </div>

          {idFromProps && (
            <div className="project-fixed-close">
              <MDBBtn color="secondary" size="sm" onClick={this.handleClose}>
                Cerrar
              </MDBBtn>
            </div>
          )}
        </ModalPortal>

        {/* Modales */}
        {modal.open && modal.type === "cast" && (
          <CastItemModal
            item={modal.payload?.item || modal.payload}
            onClose={this.closeModal}
            onDelete={
              modal.index >= 0
                ? () => {
                    const roleIndex = modal.payload?.roleIndex;
                    if (Number.isInteger(roleIndex) && roleIndex >= 0) {
                      this.setState((s) => {
                        const personajes = (s.project.personajes || []).slice();
                        const personaje = personajes[modal.index];
                        if (!personaje) return null;

                        const roles = (personaje.roles || []).slice();
                        if (roleIndex >= roles.length) return null;

                        roles.splice(roleIndex, 1);
                        if (roles.length > 0) {
                          personajes[modal.index] = { ...personaje, roles };
                        } else {
                          personajes.splice(modal.index, 1);
                        }

                        return { project: { ...s.project, personajes } };
                      });
                    } else {
                      this.removeItem("Maestros", modal.index);
                    }
                    this.closeModal();
                  }
                : null
            }
            onSave={(item) => {
              const roleIndex = modal.payload?.roleIndex;
              if (
                modal.index >= 0 &&
                Number.isInteger(roleIndex) &&
                roleIndex >= 0
              ) {
                this.setState((s) => {
                  const personajes = (s.project.personajes || []).slice();
                  const personaje = personajes[modal.index];
                  if (!personaje) return null;

                  const roles = (personaje.roles || []).slice();
                  const incomingRole = item?.roles?.[0] || null;
                  if (!incomingRole || roleIndex >= roles.length) return null;

                  roles[roleIndex] = { ...roles[roleIndex], ...incomingRole };
                  personajes[modal.index] = {
                    ...personaje,
                    name: item?.name ?? personaje.name,
                    status: item?.status ?? personaje.status,
                    description: item?.description ?? personaje.description,
                    imageBase64: item?.imageBase64 ?? personaje.imageBase64,
                    imageUuid:
                      Object.prototype.hasOwnProperty.call(item || {}, "imageUuid")
                        ? item.imageUuid
                        : personaje.imageUuid,
                    roles,
                  };

                  return { project: { ...s.project, personajes } };
                }, this.handleSaveCastOnly);
              } else {
                this.upsertItem("Maestros", modal.index, item, this.handleSaveCastOnly);
              }
              this.closeModal();
            }}
          />
        )}

        {modal.open && modal.type === "gallery" && (
          <GalleryItemModal
            item={modal.payload}
            onClose={this.closeModal}
            onDelete={
              modal.index >= 0
                ? () => {
                    this.removeItem("fotos", modal.index);
                    this.closeModal();
                  }
                : null
            }
            onSave={(item) => {
              this.upsertItem("fotos", modal.index, item);
              this.closeModal();
            }}
          />
        )}

        {modal.open && modal.type === "video" && (
          <VideoItemModal
            item={modal.payload}
            onClose={this.closeModal}
            onDelete={
              modal.index >= 0
                ? () => {
                    this.removeItem("videos", modal.index);
                    this.closeModal();
                  }
                : null
            }
            onSave={(item) => {
              this.upsertItem("videos", modal.index, item);
              this.closeModal();
            }}
          />
        )}

        {modal.open && modal.type === "venue" && (
          <VenueItemModal
            item={modal.payload}
            onClose={this.closeModal}
            onDelete={
              modal.index >= 0
                ? () => {
                    this.removeItem("representaciones", modal.index);
                    this.closeModal();
                  }
                : null
            }
            onSave={(item) => {
              this.upsertItem("representaciones", modal.index, item, this.handleSaveVenueOnly);
              this.closeModal();
            }}
          />
        )}

        {modal.open && modal.type === "comment" && (
          <CommentItemModal
            item={modal.payload}
            onClose={this.closeModal}
            onDelete={
              modal.index >= 0
                ? () => {
                    this.removeItem("comentarios", modal.index);
                    this.closeModal();
                  }
                : null
            }
            onSave={(item) => {
              this.upsertItem("comentarios", modal.index, item);
              this.closeModal();
            }}
          />
        )}
      </div>
    );
  }
}
